import { render, staticRenderFns } from "./aiKnowledgeDetail.vue?vue&type=template&id=1935ad4c&scoped=true"
import script from "./aiKnowledgeDetail.vue?vue&type=script&lang=js"
export * from "./aiKnowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./aiKnowledgeDetail.vue?vue&type=style&index=0&id=1935ad4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935ad4c",
  null
  
)

export default component.exports